import stringify from "safe-stable-stringify";
// Simple hash function for change detection
export const simpleStableHash = (obj) => {
    const str = stringify(obj) ?? "";
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    return hash.toString(36);
};
//# sourceMappingURL=index.js.map